import { apiSlice } from "../../app/api/apiSlice";

export const galleryImagesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // =============================
    // GET IMAGES
    // =============================

    getGalleryImages: builder.query({

      query: ({ page = 1, limit = 12, event, category }) => {

        let url = `/api/v1/gallery/images?page=${page}&limit=${limit}`;

        if (event) url += `&event=${event}`;
        if (category) url += `&category=${category}`;

        return url;
      },

      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },

      // pagination cache merge
      merge: (currentCache, newCache) => {

        if (!currentCache.data) {
          currentCache.data = [];
        }

        if (newCache?.data) {

          const existingIds = new Set(
            currentCache.data.map((item) => item._id)
          );

          const uniqueNewItems = newCache.data.filter(
            (item) => !existingIds.has(item._id)
          );

          currentCache.data.push(...uniqueNewItems);

        }

        currentCache.page = newCache.page;
        currentCache.totalPages = newCache.totalPages;

      },

      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.page !== previousArg?.page;
      },

      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "GalleryImage",
                id: _id,
              })),
              { type: "GalleryImage", id: "LIST" },
            ]
          : [{ type: "GalleryImage", id: "LIST" }],

      keepUnusedDataFor: 300,

    }),


    // =============================
    // SINGLE IMAGE UPLOAD
    // =============================

    uploadGalleryImage: builder.mutation({
      query: (formData) => ({
        url: "/api/v1/admin/gallery/images",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "GalleryImage", id: "LIST" }],
    }),


    // =============================
    // BULK IMAGE UPLOAD ⭐
    // =============================

    uploadBulkGalleryImages: builder.mutation({
      query: (formData) => ({
        url: "/api/v1/admin/gallery/images/bulk",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "GalleryImage", id: "LIST" }],
    }),


    // =============================
    // UPDATE IMAGE
    // =============================

    updateGalleryImage: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/api/v1/admin/gallery/images/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "GalleryImage", id: arg.id },
        { type: "GalleryImage", id: "LIST" },
      ],
    }),


    // =============================
    // DELETE IMAGE
    // =============================

    deleteGalleryImage: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/gallery/images/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "GalleryImage", id: "LIST" }],
    }),

  }),
});

export const {
  useGetGalleryImagesQuery,
  useUploadGalleryImageMutation,
  useUploadBulkGalleryImagesMutation, // ⭐ NEW
  useUpdateGalleryImageMutation,
  useDeleteGalleryImageMutation,
} = galleryImagesApiSlice;